module.exports = __webpack_public_path__ + "static/media/Search-chartreuse.7dfe1c19.svg";